const UNITS = ["B", "KB", "MB", "GB", "TB"];

/** Human-readable byte size, e.g. 1536 → "1,5 KB". */
export function formatBytes(bytes: number): string {
  if (!bytes || bytes < 0) return "0 B";
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  const rounded = unit === 0 ? value : Math.round(value * 10) / 10;
  return `${String(rounded).replace(".", ",")} ${UNITS[unit]}`;
}

/** Percentage of the quota used (0–100), clamped. */
export function usedPercent(used: number, quota: number): number {
  if (!quota) return 0;
  return Math.min(100, Math.round((used / quota) * 100));
}

/** Data i godzina w polskim zapisie, np. „12.09.2026, 14:03". */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("pl-PL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
